<template>
    <div class="translate-panel" :class="{ 'dark-theme': shouldUseDarkTheme }" :data-theme="shouldUseDarkTheme ? 'dark' : 'light'">
        <div class="translate-header">
            <div class="translate-title" v-if="!notupdate">
                translate into:
                <el-select :disabled="isButtonDisabled" v-model="selectedLanguage" placeholder="Select Language"
                    size="small">
                    <el-option v-for="lang in languages" :key="lang.code" :label="lang.fullname" :value="lang.name">
                    </el-option>
                </el-select>
                <el-button type="success" size="small" @click="startTranslate" :loading="isTranslating"
                    :disabled="isButtonDisabled">
                    {{ getButtonText }}
                </el-button>
            </div>
            <div class="translate-actions">
                <el-dropdown class="export" @command="handleCommand">
                    <span class="el-dropdown-link">
                        Copy as<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="copymarkdown" icon="el-icon-c-scale-to-original">Copy as
                            Markdown</el-dropdown-item>
                        <el-dropdown-item command="copytext" icon="el-icon-tickets">Copy as
                            TXT</el-dropdown-item>
                        <el-dropdown-item command="downloadaspdf" icon="el-icon-download">Download as
                            PDF</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>

        <div class="translate-content">
            <div class="guide-tips" v-if="!translatedContent && !isTranslating">
                <div class="tip-box tip-1">
                    <div class="tip-content">
                        <i class="el-icon-info"></i>
                        Select your target language and click "Get it Now" to start translation
                    </div>
                </div>
                <div class="tip-box tip-2">
                    <div class="tip-content">
                        <i class="el-icon-info"></i>
                        After translation, you can copy the content as Markdown or TXT format
                    </div>
                </div>
            </div>
            <div v-else-if="!translatedContent && isTranslating" class="loading-container">
                <el-progress type="circle" :percentage="translateProgress"></el-progress>
                <p class="loading-text">Translating your notes...</p>
            </div>
            <div class="translated-text" ref="contentToDownload" v-else v-html="translatedContent"></div>
        </div>


    </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
export default {
    name: 'TranslateToggle',
    data() {
        return {
            currentTheme: 'light', // 添加主题状态
            selectedLanguage: 'English',
            // 语言列表，按字母顺序排列
            languages: [
                { code: "EN", name: "English", fullname: "English" },
                { code: "ZH", name: "Chinese", fullname: "简体中文" },
                { code: "ZH(T)", name: "Traditional Chinese (Hong Kong)", fullname: "繁体中文" },
                { code: "ES", name: "Spanish", fullname: "Spanish" },
                { code: "FR", name: "French", fullname: "French" },
                { code: "DE", name: "German", fullname: "German" },
                { code: "IT", name: "Italian", fullname: "Italian" },
                { code: "JA", name: "Japanese", fullname: "Japanese" },
                { code: "RU", name: "Russian", fullname: "Russian" },
                { code: "AR", name: "Arabic", fullname: "Arabic" },
                { code: "HI", name: "Hindi", fullname: "Hindi" },
                { code: "PT", name: "Portuguese", fullname: "Portuguese" },
                { code: "NL", name: "Dutch", fullname: "Dutch" },
                { code: "KO", name: "Korean", fullname: "Korean" },
                { code: "TR", name: "Turkish", fullname: "Turkish" },
            ],

            md: new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(lang, str).value;
                        } catch (__) {
                            console.log("error", str, lang);
                        }
                    }
                    return ""; // 使用默认的转义
                },
            }),

            note_translate: '',
            isTranslating: false,
            hasTranslated: false,
            translateProgress: 0,
            translateStatus: '',
            progressTimer: null,
            disableEndTime: null,  // 禁用结束时间戳
            currentTimestamp: Date.now(),  // 当前时间戳
            disableTimer: null,  // 禁用状态的定时器
            isPolling: false, // 添加轮询状态标记
            pollTimer: null,
        }
    },
    props: {
        noteobj: {
            type: Object,
            default: null
        },
        notupdate: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        noteobj: {
            handler(newVal) {
                console.log("noteobj", newVal);
                this.note_translate = newVal.note_translate
                if (!this.note_translate) {
                    this.checkTranslatingState()
                }
            },
            deep: true
        },
        'noteobj.noteid': {
            handler(newVal) {
                if (newVal) {
                    this.hasTranslated = false;
                    this.isTranslating = false;
                    this.note_translate = '';
                    this.clearProgressAnimation();
                }
            },
            immediate: true
        },
        selectedLanguage(newVal, oldVal) {
            if (newVal !== oldVal && oldVal) {
                this.hasTranslated = false;
                // this.note_translate = '';
            }
        }
    },
    mounted() {
        // 初始化主题
        const savedTheme = localStorage.getItem('easynote-translate-theme');
        if (savedTheme) {
            this.currentTheme = savedTheme;
        } else {
            // 从父组件或全局主题设置中获取初始主题
            const globalTheme = localStorage.getItem('easynote-theme-preference');
            this.currentTheme = globalTheme === 'dark' ? 'dark' : 'light';
        }

        this.note_translate = this.noteobj.note_translate;
        if (!this.note_translate) {
            this.checkTranslatingState()
        }
        //打印当前路由
        console.log("current route", this.$route.path);
    },
    computed: {
        shouldUseDarkTheme() {
            // 优先使用组件内部的主题状态
            return this.currentTheme === 'dark';
        },
        translatedContent() {
            if (this.note_translate) {
                return this.md.render(this.note_translate);
            } else {
                return ''
            }
        },
        isButtonDisabled() {
            return this.isTranslating || (this.disableEndTime && this.currentTimestamp < this.disableEndTime);
        },
        getButtonText() {
            if (this.isTranslating) {
                return 'Translating...';
            }
            if (this.disableEndTime && this.currentTimestamp < this.disableEndTime) {
                const remainingSeconds = Math.ceil((this.disableEndTime - this.currentTimestamp) / 1000);
                return `wait ${remainingSeconds}s`;
            }
            return 'Get it Now';
        }
    },
    methods: {
        // 添加主题切换方法
        onThemeChange(isDarkTheme) {
            this.currentTheme = isDarkTheme ? 'dark' : 'light';
            // 保存到 localStorage
            localStorage.setItem('easynote-translate-theme', this.currentTheme);
            // 强制重新渲染以确保主题变化生效
            this.$forceUpdate();
        },
        async startTranslate() {
            if (!this.selectedLanguage) {
                this.$message.warning('Please select a language first')
                return
            }
            // 如果翻译语言跟源语言相同，则不进行翻译
            if (this.selectedLanguage == this.noteobj.language) {
                this.$message.warning('Please change to a different language')
                return
            }

            if (this.isTranslating || this.hasTranslated) {
                return
            }

            // console.log("startTranslate", this.noteobj, this.selectedLanguage);
            // 清除当前翻译
            if (this.note_translate) {
                this.note_translate = '';
                this.hasTranslated = false;
                this.isTranslating = false;
                this.clearProgressAnimation();
            }


            this.isTranslating = true;
            this.startProgressAnimation();
            const subid = this.$cookies.get('subid');
            
            // 根据笔记类型为note_text赋值
            let note_text = '';
            if (this.noteobj.filetype === 'record' && this.noteobj?.live_transcript?.part_objs) {
                // 如果是录音类型，拼接live_transcript中的内容
                let mknotes = '';
                this.noteobj.live_transcript.part_objs.forEach((item) => {
                    mknotes = mknotes + item.notes;
                });
                note_text = mknotes;
            } else {
                // 其他类型直接使用note_text
                note_text = this.noteobj.note_text;
            }
            
            try {
                const res = await this.$axios.post('/api/set_translate_note/', {
                    noteid: this.noteobj.noteid,
                    language: this.selectedLanguage,
                    note_text: note_text,
                    subid: subid,
                })
                const redata = res.data
                if (redata.code == 200) {
                    const noteid = redata.noteid
                    // 设置正在翻译的笔记ID和语言
                    this.$cookies.set('translating_note', JSON.stringify({
                        noteid: this.noteobj.noteid,
                        language: this.selectedLanguage,
                        timestamp: Date.now()
                    }), '1d')  // 1天后过期

                    let noteobj = this.noteobj
                    noteobj.note_translate = '';
                    this.$emit('setnoteobj', noteobj)
                    this.getTranslateResult(noteid)
                    // this.$message.success("Translation started successfully");
                } else {
                    this.$message.error(redata.messages);
                    this.isTranslating = false;
                    this.clearProgressAnimation();
                }
            } catch (error) {
                this.$message.error("Failed to start translation");
                this.isTranslating = false;
                this.clearProgressAnimation();
            }
        },
        startProgressAnimation() {
            this.translateProgress = 0;
            let startTime = Date.now();
            const TOTAL_TIME = 120000; // 2分钟

            this.progressTimer = setInterval(() => {
                const elapsedTime = Date.now() - startTime;
                const progress = Math.min(99, Math.floor((elapsedTime / TOTAL_TIME) * 100));

                if (progress >= 99) {
                    clearInterval(this.progressTimer);
                }

                this.translateProgress = progress;
            }, 1000); // 每秒更新一次
        },
        clearProgressAnimation() {
            if (this.progressTimer) {
                clearInterval(this.progressTimer);
                this.progressTimer = null;
            }
            this.translateProgress = 0;
        },
        async getTranslateResult(noteid) {
            // 如果已经在轮询中，直接返回
            if (this.isPolling) {
                return;
            }

            try {
                this.isPolling = true; // 设置轮询状态

                // 创建轮询函数
                const pollTranslation = async () => {
                    const res = await this.$axios.post('/api/get_translate_note/', {
                        noteid: noteid,
                    });

                    const redata = res.data;
                    if (redata.code == 200) {
                        // 获取到结果
                        this.note_translate = redata.note_translate;
                        this.isTranslating = false;
                        this.hasTranslated = true;
                        this.clearProgressAnimation();
                        this.$message.success("Translation completed successfully");
                        this.startDisableTimer();
                        this.isPolling = false; // 清除轮询状态
                        this.clearTranslatingState(); // 清除翻译状态

                        // 停止轮询
                        if (this.pollTimer) {
                            clearTimeout(this.pollTimer);
                            this.pollTimer = null;
                        }
                    } else if (redata.code == 202) {
                        // 继续轮询
                        this.pollTimer = setTimeout(() => pollTranslation(), 3000);
                    } else {
                        throw new Error(redata.messages || 'Translation failed');
                    }
                };

                // 开始轮询
                await pollTranslation();

            } catch (error) {
                this.isTranslating = false;
                this.clearProgressAnimation();
                this.$message.error(error.message || "Translation failed");
                this.isPolling = false; // 发生错误时也要清除轮询状态

                // 出错时也要清除轮询定时器
                if (this.pollTimer) {
                    clearTimeout(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        },
        copyToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message({ message: "Copied to clipboard", type: "success" });
                }).catch((err) => {
                    console.error('Could not copy text: ', err);
                });
            } else {
                // 使用旧的方法复制到剪贴板
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.$message({ message: "Copied to clipboard", type: "success" });
                } catch (err) {
                    console.error('Could not copy text: ', err);
                }
                document.body.removeChild(textArea);
            }
        },
        handleCommand(command) {
            switch (command) {
                case "copymarkdown":
                    this.copymarkdown();
                    break;
                case "copytext":
                    this.copytext();
                    break;
                case "downloadaspdf":
                    this.downloadaspdf('contentToDownload');
                    break;
                default:
                    break;
            }
        },
        copymarkdown() {
            // console.log("copymarkdown", this.noteobj);
            const markdownContent = this.noteobj.note_translate;
            this.copyToClipboard(markdownContent);
        },
        copytext() {
            const textContent = this.htmlToText(this.translatedContent);
            this.copyToClipboard(textContent);
        },
        downloadaspdf(resobj) {
            // this.generateA4PaginatedPdf();
            this.printPdf(resobj);
        },
        async printPdf(resobj) {
            try {
                // 获取打印容器
                const printContainer = this.$refs[resobj];
                if (!printContainer || !printContainer.innerHTML.trim()) {
                    throw new Error('No content to print');
                }

                // 创建一个隐藏的 iframe
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.top = '-9999px';
                iframe.style.left = '-9999px';
                document.body.appendChild(iframe);

                // 将打印容器的内容复制到 iframe 中
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(`
      <html>
        <head>
          <title>打印内容</title>
          <style>
            /* 添加你需要的样式 */
            body {
              font-family: Arial, sans-serif;
            }
            .print-container {
              padding: 20px;
            }
            ${this.getAdditionalStyles()} /* 获取额外需要的样式 */
          </style>
        </head>
        <body>
          ${printContainer.innerHTML}
        </body>
      </html>
    `);
                iframeDocument.close();

                // 等待 iframe 加载完成
                await new Promise((resolve) => {
                    iframe.onload = resolve;
                });

                // 等待一小段时间，确保所有内容都已渲染
                await new Promise((resolve) => setTimeout(resolve, 1000));

                // 调用浏览器的打印功能
                iframe.contentWindow.print();

                // 移除 iframe
                document.body.removeChild(iframe);
            } catch (error) {
                console.error('PDF打印失败:', error);
                alert('PDF打印失败，请稍后重试或联系支持人员。');
            }
        },
        // 获取额外需要的样式
        getAdditionalStyles() {
            // 这里可以返回任何额外需要的CSS
            return `
    /* 额外的CSS样式 */
    .custom-class {
      color: #333;
    }
  `;
        },
        htmlToText(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        startDisableTimer() {
            // 使用时间戳
            this.disableEndTime = Date.now() + 60000; // 1分钟后解除禁用

            if (this.disableTimer) {
                clearInterval(this.disableTimer);
            }

            this.disableTimer = setInterval(() => {
                this.currentTimestamp = Date.now();
                if (this.currentTimestamp >= this.disableEndTime) {
                    this.clearDisableState();
                }
            }, 1000);
        },
        clearDisableState() {
            if (this.disableTimer) {
                clearInterval(this.disableTimer);
                this.disableTimer = null;
            }
            this.disableEndTime = null;
        },
        clearTranslatingState() {
            this.$cookies.remove('translating_note')
        },
        async checkTranslatingState() {
            const translatingNote = JSON.parse(this.$cookies.get('translating_note') || '{}')
            if (translatingNote &&
                translatingNote.noteid === this.noteobj.noteid &&
                !this.note_translate) {
                // 如果存在翻译记录且是当前笔记，并且还没有翻译结果

                // 开始轮询翻译结果
                if (!this.noteobj.noteid) {
                    return
                }
                this.isTranslating = true;
                this.selectedLanguage = translatingNote.language
                this.startProgressAnimation();
                this.getTranslateResult(this.noteobj.noteid)
            }
        }
    },
    beforeDestroy() {
        this.clearProgressAnimation();
        this.clearDisableState();
        // 组件销毁时清除轮询定时器
        if (this.pollTimer) {
            clearTimeout(this.pollTimer);
            this.pollTimer = null;
        }
        this.isPolling = false;
    }
}
</script>

<style lang="less" scoped>
/* CSS变量 - 浅色主题 */
.translate-panel {
    --text-color: #333333;
    --text-light: #666666;
    --background-color: #ffffff;
    --background-light: #f8f9fa;
    --border-color: #e6e8ed;
    --border-light: rgba(0, 0, 0, 0.06);
    --shadow-color: rgba(0, 0, 0, 0.08);
    --shadow-light: rgba(0, 0, 0, 0.04);
    --card-bg: rgba(245, 245, 245, 0.9);
    --button-bg: #f0f0f0;
    --button-text: #333;
    --button-hover-bg: #e0e0e0;
    --primary-color: #4a7bff;
    --primary-light: #eef1ff;
    --success-color: #34c759;
    --info-color: #409EFF;
    --tip-bg: rgba(255, 255, 255, 0.1);
    --tip-text: #bbbbbb;
    --export-bg: rgba(255, 255, 255, 0.2);
    --export-hover-bg: rgba(255, 255, 255, 0.4);
    --progress-text: #ffffff;
    --rendered-bg: #fcfcfc;
    --rendered-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.03);
    --main-text-color: #333;
    --h1-color: #222;
    --h2-color: #222;
    --h3-color: #333;
    --h4-color: #444;
    --h5-color: #555;
    --h6-color: #666;
    --p-color: #444;
    --strong-color: #222;
    --em-color: #555;
    --li-color: #444;
    --blockquote-bg: #f7faff;
    --blockquote-text: #4a5568;
    --blockquote-border: #4a7bff;
    --code-bg: rgba(74, 123, 255, 0.08);
    --code-color: #4a7bff;
    --pre-bg: #f8fafd;
    --pre-border: rgba(0, 0, 0, 0.03);
    --pre-code-color: #333;
    --table-bg: #fff;
    --th-bg: #f7faff;
    --th-color: #2c3e50;
    --td-color: #34495e;
    --table-border: rgba(0, 0, 0, 0.06);
    --table-hover: rgba(74, 123, 255, 0.04);
    --table-even: rgba(0, 0, 0, 0.01);
    --link-color: #4a7bff;
    --link-border: rgba(74, 123, 255, 0.3);
    --hr-color: rgba(0, 0, 0, 0.08);
    --scrollbar-track: rgba(0, 0, 0, 0.02);
    --scrollbar-thumb: rgba(0, 0, 0, 0.08);
    --scrollbar-thumb-hover: rgba(0, 0, 0, 0.15);

    /* 深色主题变量 */
    &.dark-theme, &[data-theme="dark"] {
        --text-color: #e4e6ea;
        --text-light: #aaaaaa;
        --background-color: #1a1a1a;
        --background-light: #2a2a2a;
        --border-color: #3a3a3a;
        --border-light: rgba(255, 255, 255, 0.1);
        --shadow-color: rgba(0, 0, 0, 0.3);
        --shadow-light: rgba(0, 0, 0, 0.2);
        --card-bg: rgba(42, 42, 42, 0.9);
        --button-bg: #3a3a3a;
        --button-text: #e4e6ea;
        --button-hover-bg: #4a4a4a;
        --primary-color: #5d6fff;
        --primary-light: #232748;
        --success-color: #34c759;
        --info-color: #58a6ff;
        --tip-bg: rgba(255, 255, 255, 0.05);
        --tip-text: #c9ccd1;
        --export-bg: rgba(255, 255, 255, 0.1);
        --export-hover-bg: rgba(255, 255, 255, 0.2);
        --progress-text: #e4e6ea;
        --rendered-bg: #1e1e1e;
        --rendered-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
        --main-text-color: #e4e6ea;
        --h1-color: #ffffff;
        --h2-color: #ffffff;
        --h3-color: #e4e6ea;
        --h4-color: #e4e6ea;
        --h5-color: #c7ccd3;
        --h6-color: #c7ccd3;
        --p-color: #c9ccd1;
        --strong-color: #ffffff;
        --em-color: #b3b8c4;
        --li-color: #c9ccd1;
        --blockquote-bg: rgba(93, 111, 255, 0.08);
        --blockquote-text: #c7ccd3;
        --blockquote-border: #5d6fff;
        --code-bg: rgba(93, 111, 255, 0.12);
        --code-color: #5d6fff;
        --pre-bg: #161b22;
        --pre-border: rgba(255, 255, 255, 0.1);
        --pre-code-color: #e0e0e0;
        --table-bg: #1e1e1e;
        --th-bg: #2a2a2a;
        --th-color: #e4e6ea;
        --td-color: #c9ccd1;
        --table-border: rgba(255, 255, 255, 0.06);
        --table-hover: rgba(93, 111, 255, 0.08);
        --table-even: rgba(255, 255, 255, 0.02);
        --link-color: #58a6ff;
        --link-border: rgba(88, 166, 255, 0.3);
        --hr-color: rgba(255, 255, 255, 0.1);
        --scrollbar-track: rgba(255, 255, 255, 0.02);
        --scrollbar-thumb: rgba(255, 255, 255, 0.1);
        --scrollbar-thumb-hover: rgba(255, 255, 255, 0.2);
    }

    flex: 1;
    max-height: calc(100vh - 130px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    background-color: var(--background-color);
    color: var(--text-color);
    transition: all 0.3s ease;

    .translate-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--text-color);

        .translate-title {
            display: flex;
            align-items: center;
            gap: 10px;
            color: var(--text-color);

            :deep(.el-select) {
                width: 150px;
                
                .el-input__inner {
                    background-color: var(--button-bg) !important;
                    border-color: var(--border-color) !important;
                    color: var(--text-color) !important;
                }
            }
        }

        .translate-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            .export {
                position: absolute;
                right: 20px;
                top: 5px;
                background: var(--export-bg);
                color: var(--text-color);
                border: none;
                font-size: 16px;
                padding: 0.4vw 1vw;
                cursor: pointer;
                border-radius: 0.5vw;
                transition: all 0.3s ease;

                &:hover {
                    background: var(--export-hover-bg);
                }
            }
        }
    }

    .translate-content {
        flex: 1;
        overflow-y: auto;

        .guide-tips {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 40px;
            padding: 0 20%;

            .tip-box {
                background: var(--tip-bg);
                border-radius: 8px;
                padding: 20px;

                .tip-content {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    color: var(--tip-text);
                    font-size: 16px;

                    i {
                        font-size: 24px;
                        color: var(--info-color);
                    }
                }
            }
        }
        
        .translated-text {
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            line-height: 1.8;
            color: var(--main-text-color) !important;
            max-width: 900px;
            margin: 0 auto;
            font-size: 16px;
            letter-spacing: 0.3px;
            background-color: var(--rendered-bg) !important;
            border-radius: 12px;
            box-shadow: var(--rendered-shadow);
            padding: 15px 20px 24px;
            
            /* 滚动条样式 */
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: var(--scrollbar-track);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background: var(--scrollbar-thumb);
                border-radius: 4px;
                transition: background 0.3s ease;

                &:hover {
                    background: var(--scrollbar-thumb-hover);
                }
            }

            &::-webkit-scrollbar-corner {
                background: transparent;
            }

            scrollbar-width: thin;
            scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

            :deep(h1) {
                font-size: 22px !important;
                font-weight: 600 !important;
                margin: 1.2em 0 0.8em !important;
                color: var(--h1-color) !important;
                border-bottom: 2px solid var(--border-light) !important;
                padding-bottom: 0.3em !important;
                position: relative !important;
                
                &::after {
                    content: '' !important;
                    position: absolute !important;
                    left: 0 !important;
                    bottom: -2px !important;
                    width: 80px !important;
                    height: 2px !important;
                    background: linear-gradient(90deg, var(--primary-color) 0%, rgba(74, 123, 255, 0.3) 100%) !important;
                }
            }

            :deep(h2) {
                font-size: 20px !important;
                font-weight: 600 !important;
                margin: 1.2em 0 0.8em !important;
                color: var(--h2-color) !important;
                padding-bottom: 0.2em !important;
                border-bottom: 1px solid var(--border-light) !important;
            }

            :deep(h3) {
                font-size: 18px !important;
                font-weight: 500 !important;
                margin: 1.2em 0 0.7em !important;
                color: var(--h3-color) !important;
            }

            :deep(h4) {
                font-size: 1.3em !important;
                font-weight: 500 !important;
                margin: 1.2em 0 0.6em !important;
                color: var(--h4-color) !important;
            }

            :deep(h5) {
                font-size: 1.1em !important;
                font-weight: 500 !important;
                margin: 1.2em 0 0.5em !important;
                color: var(--h5-color) !important;
            }

            :deep(h6) {
                font-size: 1em !important;
                font-weight: 500 !important;
                margin: 1.2em 0 0.5em !important;
                color: var(--h6-color) !important;
            }

            :deep(p) {
                margin: 1.3em 0 !important;
                line-height: 1.8 !important;
                color: var(--p-color) !important;
            }

            :deep(strong) {
                color: var(--strong-color) !important;
                font-weight: 600 !important;
            }

            :deep(em) {
                color: var(--em-color) !important;
            }

            :deep(ul),
            :deep(ol) {
                padding-left: 1.8em !important;
                margin: 1.2em 0 !important;

                li {
                    margin: 0.6em 0 !important;
                    line-height: 1.6 !important;
                    color: var(--li-color) !important;
                    padding-left: 0.5em !important;
                    
                    &::marker {
                        color: var(--primary-color) !important;
                    }
                }
            }

            :deep(blockquote) {
                margin: 1.8em 0 !important;
                padding: 1em 1.2em !important;
                border-left: 4px solid var(--blockquote-border) !important;
                background: var(--blockquote-bg) !important;
                border-radius: 8px !important;
                box-shadow: 0 2px 8px rgba(74, 123, 255, 0.07) !important;
                position: relative !important;
                overflow: hidden !important;

                &::before {
                    content: '"' !important;
                    position: absolute !important;
                    top: -10px !important;
                    left: 10px !important;
                    font-size: 5em !important;
                    color: rgba(74, 123, 255, 0.1) !important;
                    font-family: serif !important;
                    line-height: 1 !important;
                }

                p {
                    margin: 0.5em 0 !important;
                    color: var(--blockquote-text) !important;
                    position: relative !important;
                    font-style: italic !important;
                }
            }

            :deep(code) {
                font-family: 'JetBrains Mono', 'Fira Code', monospace !important;
                background: var(--code-bg) !important;
                padding: 0.2em 0.4em !important;
                border-radius: 4px !important;
                font-size: 16px !important;
                color: var(--code-color) !important;
                font-weight: 500 !important;
                letter-spacing: -0.3px !important;
            }

            :deep(pre) {
                background: var(--pre-bg) !important;
                padding: 1.4em !important;
                border-radius: 12px !important;
                overflow-x: auto !important;
                margin: 1.8em 0 !important;
                border: 1px solid var(--pre-border) !important;
                box-shadow: 0 3px 15px rgba(0, 0, 0, 0.04) !important;
                position: relative !important;

                code {
                    background: none !important;
                    padding: 0 !important;
                    font-size: 16px !important;
                    color: var(--pre-code-color) !important;
                    text-shadow: none !important;
                    white-space: pre !important;
                    word-spacing: normal !important;
                    word-break: normal !important;
                    tab-size: 4 !important;
                    hyphens: none !important;
                    font-weight: 400 !important;
                    letter-spacing: normal !important;
                }
            }

            :deep(table) {
                width: 100% !important;
                border-collapse: separate !important;
                border-spacing: 0 !important;
                margin: 1.5em 0 !important;
                border-radius: 12px !important;
                overflow: hidden !important;
                box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05) !important;
                background: var(--table-bg) !important;
                font-size: 16px !important;
                line-height: 1.6 !important;

                th,
                td {
                    border: none !important;
                    border-bottom: 1px solid var(--table-border) !important;
                    padding: 14px 18px !important;
                    text-align: left !important;
                    position: relative !important;
                }

                th {
                    background: var(--th-bg) !important;
                    font-weight: 600 !important;
                    color: var(--th-color) !important;
                    font-size: 16px !important;
                    text-transform: capitalize !important;
                    border-bottom: 2px solid rgba(74, 123, 255, 0.2) !important;
                    position: sticky !important;
                    top: 0 !important;
                    z-index: 2 !important;
                }

                tbody tr {
                    transition: all 0.2s ease !important;
                    
                    &:hover {
                        background-color: var(--table-hover) !important;
                    }
                    
                    &:last-child td {
                        border-bottom: none !important;
                    }
                }

                tr:nth-child(even) {
                    background: var(--table-even) !important;
                }
                
                td {
                    color: var(--td-color) !important;
                }
            }

            :deep(hr) {
                border: none !important;
                height: 1px !important;
                background: var(--hr-color) !important;
                margin: 2em 0 !important;
                display: block !important;
            }

            :deep(img) {
                max-width: 100% !important;
                border-radius: 8px !important;
                margin: 1.5em 0 !important;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
            }

            :deep(a) {
                color: var(--link-color) !important;
                text-decoration: none !important;
                border-bottom: 1px solid var(--link-border) !important;
                transition: all 0.3s ease !important;

                &:hover {
                    border-bottom-color: var(--link-color) !important;
                }
            }

            :deep(input[type="checkbox"]) {
                margin-right: 0.5em !important;
                cursor: pointer !important;
            }
        }
    }
}

:deep(.el-button--text) {
    color: var(--text-color);

    &:hover {
        color: var(--info-color);
    }
}

:deep(.el-select .el-input__inner) {
    background-color: var(--button-bg);
    border: 1px solid var(--border-color);
    color: var(--text-color);
}

.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 40px;

    .loading-text {
        margin-top: 20px;
        color: var(--progress-text);
        font-size: 16px;
    }
}

:deep(.el-progress) {
    .el-progress__text {
        color: var(--progress-text);
    }
}

:deep(.el-button.is-disabled) {
    background-color: #909399;
    border-color: #909399;

    &:hover {
        background-color: #909399;
        border-color: #909399;
    }
}
</style>
